<div class="container-fluid conf-component h-100">
  <div class="main-wrapper row h-100">
    @if ((!product?.detail?.no3D && product?.detail?.vestaExternalLink && !product?.detail?.underConstruction) && product?.detail?.materialNumber && product?.detail?.materialNumber != '0' && product?.detail?.colorNumber && product?.detail?.colorNumber != '0') {
      <div class="combination-materials-colors col-12 vesta-col-left pl-sm-4 pr-sm-4">
        {{
          'COMBINAZIONI_COLORI_MATERIALE' | translate: {
            materialNumber: materialNumberFormat(product?.detail?.materialNumber) | translate,
            colorNumber: product?.detail?.colorNumber
          }
        }}
      </div>
    }
    <div #vestaContainer class="col-12 vesta-col-left pl-0 pr-0 vesta-container">
      @if (!product?.detail?.no3D && product?.detail?.vestaExternalLink && enableVesta && !product?.detail?.underConstruction) {
        <app-vesta class="vesta-size" [vestaId]="product?.detail?.vestaExternalLink || null"></app-vesta>
      }
      @if ((!product?.detail?.no3D && !enableVesta) && !product?.detail?.underConstruction) {
        <img src="assets/img/logo.svg" class="logo-img-3d"/>
      }
      @if (product?.detail?.underConstruction && !product?.detail?.no3D) {
        <span class="under-costruction">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-cone-striped"
             viewBox="0 0 16 16">
          <path
            d="m9.97 4.88.953 3.811C10.159 8.878 9.14 9 8 9c-1.14 0-2.158-.122-2.923-.309L6.03 4.88C6.635 4.957 7.3 5 8 5s1.365-.043 1.97-.12zm-.245-.978L8.97.88C8.718-.13 7.282-.13 7.03.88L6.275 3.9C6.8 3.965 7.382 4 8 4c.618 0 1.2-.036 1.725-.098zm4.396 8.613a.5.5 0 0 1 .037.96l-6 2a.5.5 0 0 1-.316 0l-6-2a.5.5 0 0 1 .037-.96l2.391-.598.565-2.257c.862.212 1.964.339 3.165.339s2.303-.127 3.165-.339l.565 2.257 2.391.598z"/>
        </svg>
          {{ 'MODELLO_3D_IN_COSTRUZIONE' | translate }}
      </span>
      }
      @if (product?.detail?.no3D || (!product?.detail?.vestaExternalLink && product.detail?.images?.list && product.detail?.images?.list?.length)) {
        @if (product.detail?.images?.converted?.length) {
          <div class="width-100">
            <app-image-swiper
              [images]="product.detail?.images?.converted"
              [autoplay]="true"
              [autoplayDelay]="2500"
              [pagination]="true"
              [navigation]="false"
            />
          </div>
        }
      }

      @if (!product?.detail?.no3D && !product?.detail?.vestaExternalLink && notFound && !product?.detail?.images?.list && !product?.detail?.underConstruction) {
        <div
          class="not-found-image">
          <img alt="" src="assets/img/logo.svg">
          <p>{{ 'NO_3D' | translate }}</p>
        </div>
      }
    </div>
    <div class="vesta-button-bar">
      @if (!product?.detail?.no3D && product?.detail?.vestaExternalLink && !product?.detail?.underConstruction) {
        <button
          (click)="vestaAction(!enableVesta)" class="p-1 vesta-on-off-button"
          [ngClass]="{'vesta-button-on':enableVesta}">
          <img alt="" src="assets/img/3D/on-off.svg">
        </button>
      }
      <button (click)="forceGrouping()"
              class="vesta-apply-texture-button"
              [ngClass]="{'vesta-button-hidden':!(!product?.detail?.no3D && product?.detail?.vestaExternalLink && enableVesta && !hideButton)}">
        {{ "APPLICA_TEXTURE"| translate }}
      </button>
    </div>
    <div class="col-12 model-col-right flex-center" #colRight
         [ngClass]="{'left-toggle-drawer': isDrawerConfigurationClosed}">
      <div class="row h-100 w-100">
        <div class="flex-center left-button" (click)="toggleRightCol()">
          <i class="fa fa-chevron-left flex-center"></i>
        </div>
        <div class="right-menu">
          <div class="wrapper-history-header">
            <app-header-model
              (showConfigEvent)="visualizzaSchermataDiConfigurazione()"
              (changeModelEvent)="changeModel()"
              (goToSummaryEvent)="goToSummary()"
              [shouldOverviewButtonEnable]="shouldOverviewButtonVisible() && !preventFromGoToSummary()"
              [overviewVisible]="checkAuth()"
              class="width-100"></app-header-model>
            <!--        <app-history [enableVesta]="enableVesta" class="history"></app-history>-->
          </div>
          <div class="wrapper-body-right-menu">
            <cdk-virtual-scroll-viewport [itemSize]="1000" class="scroll-viewport-fix h-100 iubenda-padding">
              <div class="mb-4 pt-5">
                <div
                  [hidden]="!!workingPlacement || (view === configurationView.CONFIGURATION_FINAL_SUMMARY && loaded)">
                  <app-model-detail-info [detail]="product.detail"></app-model-detail-info>
                </div>
                <div [hidden]="!(view === configurationView.CONFIGURATION_SUMMARY && loaded)"
                     class="model-configuration">
                  @if (etoFlow) {
                    <div class="model-configuration-selected">
                      <h2 class="model-category">
                        <span
                          class="configuration-title">{{ 'pages.model.configuration.model.configuration.siStaModificandoLaRigaDOrdineRelativa' | translate }}</span>
                      </h2>
                    </div>
                  }
                  @if (modelConfiguration && !!modelConfiguration.selectedConfigurationData && !modelConfiguration?.newPrebuilt) {
                    <div [ngClass]="{'model-configuration-selected': modelConfiguration?.editing}">
                      @if (modelConfiguration?.editing) {
                        <div class="model-category">
                          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                               fill="none">
                            <circle cx="17" cy="17" r="17" fill="#EDE8E3"/>

                            <path d="M17 8 L25 24 H9 Z"
                                  stroke="#B3AEA8"
                                  stroke-width="1.5"
                                  fill="none"
                                  stroke-linejoin="round"/>

                            <line x1="17" y1="13" x2="17" y2="18"
                                  stroke="#B3AEA8"
                                  stroke-width="1.5"
                                  stroke-linecap="round"/>
                            <circle cx="17" cy="21.5" r="1.2" fill="#B3AEA8"/>
                          </svg>
                          <span class="model-category-change">
                        <span class="margin-left-15">{{ 'MODIFICANDO_CONFIGURAZIONE' | translate }}</span>
                        <span
                          class="ml-1 configuration-name">{{ getConfigurationName() | titlecase }}</span>
                      </span>

                          <span (click)="cancelEditingConfiguration(modelConfiguration?.selectedConfigurationData)"

                                class="model-category-change margin-left-15">
                        <svg fill="currentColor" height="25" viewBox="0 0 16 16" width="25"
                             xmlns="http://www.w3.org/2000/svg" class="bi bi-x">
                          <path
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                          </path>
                        </svg>
                      </span>

                        </div>
                      }
                    </div>
                  }
                  @if (modelConfiguration && modelConfiguration?.newPrebuilt) {
                    <div
                      class="model-configuration-new-prebuilt">
                      <div class="model-category flex-row-space-around">
                        <span>{{ 'CREANDO_CONFIGURAZIONE' | translate }}</span>
                        <span (click)="undoCreateNewPrebuilt()" class="margin-left-15">
                        <svg fill="currentColor" height="25" viewBox="0 0 16 16" width="25"
                             xmlns="http://www.w3.org/2000/svg" class="bi bi-x">
                          <path
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                          </path>
                        </svg>
                      </span>
                      </div>
                    </div>
                  }
                  <!--            <div class="margin-top-20">-->
                  <!--              <button (click)="createNewConfiguration(false)"-->
                  <!--                      class="model-buttons-custom-model">{{'NUOVA_CONFIGURAZIONE' | translate | uppercase}}-->
                  <!--              </button>-->
                  <!--            </div>-->
                  @if (!noConfigurationLines) {
                    <div class="model-configuration-content">
                      <div class="model-configuration-content-title d-flex">
                        <span>{{ 'CONFIGURAZIONI' | translate }}</span>
                      </div>
                      <mat-accordion #listsAccordion="matAccordion" [multi]="false" class="no-body-padding">
                        @if (product && product.configurazioniPrebuilt) {
                          <mat-expansion-panel class="custom-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title
                                class="configuration-section-title">{{ 'MODELLI_PRECONFIGURATI' | translate }}
                              </mat-panel-title>
                              <span class="custom-indicator" matSuffix>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                 fill="none">
                              <path d="M10.2278 4.88608L6.11392 9L2 4.88608" stroke="black"/>
                            </svg>
                          </span>
                            </mat-expansion-panel-header>
                            @if (checkIfCanBuildNewPrebuilt() && !etoFlow) {
                              <div class="margin-left-15 mb-2">
                                <button (click)="createNewConfiguration(true)"
                                        class="btn new">
                                  {{ 'NUOVA_CONFIGURAZIONE' | translate }}
                                </button>
                              </div>
                            }
                            <app-model-configurations (applyConfiguration)="applyConfiguration($event)"
                                                      (cancelEditingConfiguration)="cancelEditingConfiguration($event)"
                                                      (editingConfiguration)="editConfiguration($event)"
                                                      (newDefaultConfiguration)="createNewConfiguration(true)"
                                                      (refreshConfigurationList)="aggiornaConfigurazioni()"
                                                      [modelFamilyId]="product.detail?.modelId"
                                                      [configurations]="product.configurazioniPrebuilt"
                                                      [etoFlow]="etoFlow"
                                                      [newDefault]="checkIfCanBuildNewPrebuilt()"
                                                      [reloadImageForConfiguration]="lastModifiedConfigurationId"
                                                      [untaxedPrice]="isDefaultUntaxedPrice"
                                                      [selectedConfId]="globalConfigurationId"
                                                      (selectedConfIdChange)="globalConfigurationId = $event"
                            ></app-model-configurations>
                          </mat-expansion-panel>
                        }
                        @if (product && product.configurazioniSalvate && product.configurazioniSalvate.length > 0) {
                          <mat-expansion-panel
                            class="custom-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title
                                class="configuration-section-title">{{ 'MIE_CONFIGURAZIONI' | translate }}
                              </mat-panel-title>
                              <span class="custom-indicator" matSuffix>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                 fill="none">
                              <path d="M10.2278 4.88608L6.11392 9L2 4.88608" stroke="black"/>
                            </svg>
                          </span>
                            </mat-expansion-panel-header>

                            <app-model-configurations (applyConfiguration)="applyConfiguration($event)"
                                                      (cancelEditingConfiguration)="cancelEditingConfiguration($event)"
                                                      (editingConfiguration)="editConfiguration($event)"
                                                      (refreshConfigurationList)="aggiornaConfigurazioni()"
                                                      [modelFamilyId]="product.detail?.modelId"
                                                      [configurations]="product.configurazioniSalvate"
                                                      [savedList]="true"
                                                      [myConfigurations]="true"
                                                      [etoFlow]="etoFlow"
                                                      [reloadImageForConfiguration]="lastModifiedConfigurationId"
                                                      [untaxedPrice]="isDefaultUntaxedPrice"
                                                      [selectedConfId]="globalConfigurationId"
                                                      (selectedConfIdChange)="globalConfigurationId = $event"
                            ></app-model-configurations>
                          </mat-expansion-panel>
                        }
                        @if (product && product.configurazioniCliente && product.configurazioniCliente.length > 0) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title>{{ 'CONFIGURAZIONI_CLIENTE' | translate }}</mat-panel-title>
                            </mat-expansion-panel-header>

                            <app-model-configurations (applyConfiguration)="applyConfiguration($event)"
                                                      (cancelEditingConfiguration)="cancelEditingConfiguration($event)"
                                                      (editingConfiguration)="editConfiguration($event)"
                                                      (refreshConfigurationList)="aggiornaConfigurazioni()"
                                                      [modelFamilyId]="product.detail?.modelId"
                                                      [configurations]="product.configurazioniCliente"
                                                      [savedList]="true"
                                                      [etoFlow]="etoFlow"
                                                      [reloadImageForConfiguration]="lastModifiedConfigurationId"
                                                      [untaxedPrice]="isDefaultUntaxedPrice"
                                                      [selectedConfId]="globalConfigurationId"
                                                      (selectedConfIdChange)="globalConfigurationId = $event"
                            ></app-model-configurations>
                          </mat-expansion-panel>
                        }
                        @if (product && product.configurazioniOrdine && product.configurazioniOrdine.length > 0) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title>{{ proformaLabels.configurationsAdded | translate }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-model-configurations (applyConfiguration)="applyConfiguration($event)"
                                                      (cancelEditingConfiguration)="cancelEditingConfiguration($event)"
                                                      (editingConfiguration)="editConfiguration($event)"
                                                      (refreshConfigurationList)="aggiornaConfigurazioni()"
                                                      [modelFamilyId]="product.detail?.modelId"
                                                      [configurations]="product.configurazioniOrdine"
                                                      [savedList]="true"
                                                      [etoFlow]="etoFlow"
                                                      [reloadImageForConfiguration]="lastModifiedConfigurationId"
                                                      [untaxedPrice]="isDefaultUntaxedPrice"
                                                      [selectedConfId]="globalConfigurationId"
                                                      (selectedConfIdChange)="globalConfigurationId = $event"
                            ></app-model-configurations>
                          </mat-expansion-panel>
                        }
                      </mat-accordion>

                    </div>
                  }
                  @if (warningTimeoutObj?.canShow()) {
                    <div class="alert alert-warning alert-dismissible my-3">
                      {{ 'TIMEOUT_WARNING_HISTORY' | translate }}
                      <button type="button" class="close"
                              [attr.aria-label]="'pages.model.configuration.model.configuration.close' | translate"
                              (click)="warningTimeoutObj.show = false">
                        <span
                          aria-hidden="true">{{ 'pages.model.configuration.model.configuration.andTimes' | translate }}</span>
                      </button>
                    </div>
                  }
                  <mat-accordion>
                    <mat-expansion-panel [expanded]="showPlacementsConfigurability" class="p-0 placement-accordion">
                      <div class="row-functionalities">
                          <span class="history-func" (click)="resetConfigurationChanges()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16"
                                 fill="none">
                                <path d="M10.5 4H0.5V14H10.5V4Z" stroke="#B3AEA8" stroke-miterlimit="10"/>
                                <path d="M7.5 7L3.5 11" stroke="#B3AEA8" stroke-miterlimit="10"/>
                                <path d="M7.5 11L3.5 7" stroke="#B3AEA8" stroke-miterlimit="10"/>
                            </svg>
                            {{ "RIPARTI_DALLA_CONFIGURAZIONE_CONSIGLIATA" | translate }}</span>
                        <app-history [enableVesta]="!!enableVesta" class="history"></app-history>
                      </div>
                      @if (returnProductGroupsLength() > 0) {
                        <div class="mt-3">
                          <mat-tab-group #tabGroup (selectedTabChange)="selezionaTab($event)"
                                         [selectedIndex]="getSelectedIndex()">
                            <mat-tab [aria-label]="'GROUP_ID-UNGROUPED'"
                                     label="{{returnProductUngroupedLabel() | translate}}">
                              @for (element of product?.configurability?.ungrouped; track element) {
                                <div class="mb-2 mt-2">
                                  @for (placement of element?.ungroupedElements | sort:'index'; track placement) {
                                    @if (!isPlacementHidden(placement)) {
                                      <app-configuration-line [title]="nameForPlacement(placement)"
                                                              [controllaDifferenzaColore]="controllaDifferenzaColore(placement)"
                                                              [disabled]="checkDisabledPlacement(placement)"
                                                              [checkPlacementConf]="checkPlacementConf.bind(this, placement)"
                                                              [configurableElement]="isConfigurableElement(placement)"
                                                              [showArrow]="isConfigurableOrMutuallyExclusive(placement)"
                                                              (clickPlacement)="clickSuPlacement(placement, false, 'GROUP_ID-UNGROUPED')"
                                                              (rimuoviColore)="controllaDifferenzaColore(placement, true)"
                                      ></app-configuration-line>
                                    }
                                  }
                                </div>
                              }
                            </mat-tab>
                            @for (element of returnProductGroups(); track element) {
                              <mat-tab [aria-label]="'GROUP_ID-'+element.idGroup"
                                       [label]="element.nameGroup | titlecase">
                                <app-configuration-line [title]="element.nameGroup"
                                                        [controllaDifferenzaColore]="controllaDifferenzaColore(element)"
                                                        [disabled]="checkDisabledPlacement(element)"
                                                        [checkPlacementConf]="checkPlacementConf.bind(this, element)"
                                                        (clickPlacement)="clickSuPlacement(element, true, 'GROUP_ID-'+element.idGroup)"
                                                        (rimuoviColore)="controllaDifferenzaColore(element, true)">
                                </app-configuration-line>
                                @for (placement of element?.ungroupedElements | sort:'index'; track placement) {
                                  @if (!isPlacementHidden(placement)) {
                                    <app-configuration-line [title]="nameForPlacement(placement)"
                                                            [controllaDifferenzaColore]="controllaDifferenzaColore(placement)"
                                                            [disabled]="checkDisabledPlacement(placement)"
                                                            [checkPlacementConf]="checkPlacementConf.bind(this, placement)"
                                                            [configurableElement]="isConfigurableElement(placement)"
                                                            [showArrow]="isConfigurableOrMutuallyExclusive(placement)"
                                                            (clickPlacement)="clickSuPlacement(placement, false, 'GROUP_ID-'+element.idGroup)"
                                                            (rimuoviColore)="controllaDifferenzaColore(placement, true)">
                                    </app-configuration-line>
                                  }
                                }
                              </mat-tab>
                            }
                          </mat-tab-group>
                        </div>
                      }
                      @if (returnProductGroupsLength() === 0) {
                        <div
                          [ngClass]="modelConfiguration && !!modelConfiguration.selectedConfigurationData ? '' : 'pt-4'">
                          @for (element of product?.configurability?.ungrouped; track element) {
                            <div class="mb-2">
                              @for (placement of element?.ungroupedElements | sort:'index'; track placement) {
                                @if (!isPlacementHidden(placement)) {
                                  <app-configuration-line [title]="nameForPlacement(placement)"
                                                          [controllaDifferenzaColore]="controllaDifferenzaColore(placement)"
                                                          [disabled]="checkDisabledPlacement(placement)"
                                                          [checkPlacementConf]="checkPlacementConf.bind(this, placement)"
                                                          [configurableElement]="isConfigurableElement(placement)"
                                                          [showArrow]="isConfigurableOrMutuallyExclusive(placement)"
                                                          (clickPlacement)="clickSuPlacement(placement, false, 'GROUP_ID-UNGROUPED')"
                                                          (rimuoviColore)="controllaDifferenzaColore(placement, true)"
                                  ></app-configuration-line>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (optionalsBoxedUnboxed.length) {
                        <div class="model-name-container">
                          <h2 class="model-name">{{ 'ELEMENTI_OPZIONALI' | translate }}</h2>
                        </div>
                      }
                      @for (optional of optionalsBoxedUnboxed | sort:'index'; track optional) {
                        @if (optional.type === BoxedType.BOXED) {
                          <app-optional-boxed (configuraPlacement)="configuraPlacementOpzionale($event)"
                                              [box]="optional.optional"
                                              [checkPlacementConf]="checkPlacementConf.bind(this)"
                                              [controllaDifferenzaColore]="controllaDifferenzaColore.bind(this)"></app-optional-boxed>
                        }
                        @if (optional.type === BoxedType.UNBOXED) {
                          <app-optional-unboxed (configuraPlacement)="configuraPlacementOpzionale($event)"
                                                [checkPlacementConf]="checkPlacementConf.bind(this)"
                                                [controllaDifferenzaColore]="controllaDifferenzaColore.bind(this)"
                                                [unboxed]="optional.optional"
                                                [currentSelectedPlacement]="currentSelectedPlacement"
                                                (updateOptionalConfigurabilityEvent)="updateOptionalConfigurability()"
                                                [selectedTab]="+(modelConfiguration?.tabSelezionato || 0)"
                          ></app-optional-unboxed>
                        }
                      }
                    </mat-expansion-panel>
                  </mat-accordion>
                  @if (checkAuth() && shouldOverviewButtonVisible()) {
                    <div class="row mt-4 confirm-btn">
                      <!--                      <div class="confirm-btn-width" *ngIf="false">-->
                      <!--                        <button (click)="askEstimate()"-->
                      <!--                                [class.button-confirm-base-disabled]="preventFromGoToSummary()"-->
                      <!--                                [disabled]="preventFromGoToSummary()"-->
                      <!--                                class="model-buttons-custom-model">{{ 'RICHIEDI_PREVENTIVO' | translate | uppercase }}-->
                      <!--                        </button>-->
                      <!--                      </div>-->
                    </div>
                  }
                </div>
                <div [hidden]="!(view === configurationView.CONFIGURATION_WIDGET && (loaded || false))">
                  <div class="go-back" (click)="visualizzaSchermataDiConfigurazione()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M8.29958 11.9322L3.5 7.13259L8.29958 2.33301" stroke="black"/>
                    </svg>
                    <span class="go-back-label"> {{ 'RITORNA_INDIETRO' | translate }}</span>
                  </div>
                  <div class="placement-name-container">
                    @if (workingPlacementName()) {
                      <span class="placement-name">
                        {{ workingPlacementName() | titlecase }}
                      </span>
                    }
                  </div>
                  @if (mutuallyExclusiveOptionsGroupedLength() > 1) {
                    <h3 class="select-material">{{ 'SCEGLI_TRA' | translate }}</h3>
                  }
                  @for (groupedMutually of currentPlacementConfiguration?.mutuallyExclusiveOptions?.grouped; track groupedMutually) {
                    <h3
                      class="select-material">{{ mutuallyExclusiveOptionsGroupedLength() > 1 ? mainMutuallyNameForPlacementId(groupedMutually.placementId) : 'SCEGLI_TRA' | translate }}</h3>
                    <div class="mt-2 mb-2">
                      @for (placement of groupedMutually.mutuallyExclusiveOptions; track placement) {
                        <p (click)="selectMutuallyExclusiveOptions(placement, groupedMutually)"
                           [ngClass]="placement.selected ? 'model-material-selected-detail' : ''"
                           class="model-material">{{ placement?.optionDescription | titlecase }}</p>
                      }
                    </div>
                  }
                  @if ((currentPlacementConfiguration.mutuallyExclusiveOptions?.ungrouped || []).length > 0) {
                    <div>
                      <h3 class="select-material">{{ 'SCEGLI_TRA' | translate }}</h3>
                      @for (placement of currentPlacementConfiguration?.mutuallyExclusiveOptions?.ungrouped; track placement) {
                        <div class="mt-2 mb-2">
                          <p (click)="selectMutuallyExclusiveOptions(placement)"
                             [ngClass]="placement.selected ? 'model-material-selected-detail' : ''"
                             class="model-material">{{ placement?.optionDescription | titlecase }}
                            @if (placement.certifications && placement.certifications.length > 0) {
                              <span class="ml-1"
                                    matTooltip="{{placement.certifications.join('\n')}}" matTooltipPosition="above"
                                    matTooltipClass="certifications-mutually-tooltip">
                      <svg class="bi bi-info-circle-fill certifications-mutually-icon" fill="currentColor" height="16"
                           viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                      </svg>
                    </span>
                            }
                          </p>
                        </div>
                      }
                    </div>
                  }
                  @if (currentPlacementConfiguration.configurationList && currentPlacementConfiguration.configurationList.length > 0) {
                    <div>
                      <h3 class="select-material">{{ "SELEZIONA MATERIALE" | translate }}</h3>
                      @for (configuration of currentPlacementConfiguration?.configurationList; track configuration) {
                        <div class="mt-2 mb-2">
                          <p (click)="selectMacroMaterialConfiguration(configuration)"
                             [ngClass]="configuration.selected ? 'model-material-selected-detail' : ''"
                             class="model-material">
                            @for (element of extractSeparatedLabels(configuration?.configurationName); let last = $last; track element) {
                              <span class="model-material-elements">
                                {{ element | titlecase }}
                                @if (!last) {
                                  <span>/</span>
                                }
                              </span>
                            }
                          </p>
                        </div>
                      }
                    </div>
                  }
                  @if (currentRule?.placementsWithSameConfiguration?.length) {
                    <div class="alert alert-warning alert-warning-force">
                      {{ 'FORCE_SAME_CONFIGURATION_WARNING' | translate }}
                      <ul class="list-line-to-be-configured">
                        @for (plc of currentRule?.placementsWithSameConfiguration; track plc) {
                          <li>{{ plc.placementName | titlecase }}</li>
                        }
                      </ul>
                    </div>
                  }
                  @if (selectedWidgetConfiguration) {
                    @if (selectedWidget === widgetCode.WIDGET_ONE) {
                      <app-widget-one (selectedColor)="configurazionePlacement($event)"
                                      [canRequestEto]="canRequestEto"
                                      [widgetConfiguration]="selectedWidgetConfiguration"
                                      [ruleList]="currentRule?.mastersConfiguration || []"
                                      (goBack)="visualizzaSchermataDiConfigurazione()"></app-widget-one>
                    }
                    @if (selectedWidget === widgetCode.WIDGET_TWO) {
                      <app-widget-two (selectedColor)="configurazionePlacement($event)"
                                      [widgetConfiguration]="selectedWidgetConfiguration"
                                      [canRequestEto]="canRequestEto"
                                      [ruleList]="currentRule?.mastersConfiguration || []"
                                      (goBack)="visualizzaSchermataDiConfigurazione()"></app-widget-two>
                    }
                    @if (selectedWidget === widgetCode.WIDGET_THREE) {
                      <app-widget-three (selectedColor)="configurazionePlacement($event)"
                                        [canRequestEto]="canRequestEto"
                                        [widgetConfiguration]="selectedWidgetConfiguration"
                                        [ruleList]="currentRule?.mastersConfiguration || []"
                                        (goBack)="visualizzaSchermataDiConfigurazione()"></app-widget-three>
                    }
                  }
                </div>
                <div [hidden]="!(view === configurationView.CONFIGURATION_FINAL_SUMMARY && loaded)">
                  <div class="row mt-3 mb-3">
                    <div class="col-sm-12">
                      <div class="summary-title-container">
                        <span class="summary-title">{{ summaryData?.modelName | titlecase }}</span>
                        <p class="summary-configuration">{{ "RIEPILOGO_CONFIGURAZIONE" | translate }}</p>
                      </div>
                      @if (etoFlow) {
                        <div class="model-configuration-selected">
                          <h2 class="model-category">
                            <span
                              class="configuration-title">{{ 'pages.model.configuration.model.configuration.siStaModificandoLaRigaDOrdineRelativa' | translate }}</span>
                          </h2>
                        </div>
                      }
                      <div class="summary-model-container">
                        <span class="summary-model">{{ product?.detail?.productCode | uppercase }} -
                          {{ subCategoryString ? (subCategoryString | titlecase) : '' }}</span>
                        @if (summaryData?.productSizes) {
                          <span
                            class="summary-info">{{ "DIMENSIONI" | translate }} {{ summaryData?.productSizes }}</span>
                        }
                        @if (summaryData?.productSizes2) {
                          <span
                            class="summary-info">{{ "MISURA_SEDUTA" | translate }} {{ summaryData?.productSizes2 }}</span>
                        }
                        @if (!blockIfEtoCantRequested()) {
                          <span
                            class="summary-info">{{ "PREZZO_TOTALE" | translate }} {{ getConfigurationPrice() | translate }}</span>
                        }
                        @if (blockIfEtoCantRequested()) {
                          <div class="alert alert-danger">
                            {{ 'CONFIGURAZIONE_NON_DISPONIBILE' | translate }}
                          </div>
                        }
                      </div>

                    </div>
                  </div>
                  @if (canShowSaveEditing() && !blockIfEtoCantRequested() && b2cAddToOrderEnabled) {
                    <div (click)="!editingSaved && saveEditing()"
                         [class.button-confirm-base-disabled]="editingSaved"
                         class="col-sm-12 summary-button-container summary-button-container-add mb-4 summary-button-label summary-button-label-add">
                      {{ (!editingSaved ? "SALVA_MODIFICHE" : "MODIFICHE_SALVATE") | translate }}
                    </div>
                  }
                  @if (disclaimerTime) {
                    <div class="alert alert-info">
                      {{ disclaimerTimeValue }}
                    </div>
                  }
                  @if (showSummaryRecap()) {
                    <div class="alert summary-recap">
                      <div class="details"><span>{{ 'DETTAGLI' | translate }}</span></div>
                      {{ 'YOUR_CONF_CODE' | translate }}: <span
                      class="font-weight-700">{{ summaryData?.configurationSaleCode }}</span>
                      <div class="mt-1"><span class="code">{{ 'GIVE_THIS_CODE_TO' | translate }}</span></div>
                      @if (summaryData?.configurationDescriptionList?.length) {
                        <div class="mt-4 mb-2">
                          <span>{{ 'SUMMARY' | translate }}:</span>
                          <div class="mt-2">
                            @for (line of summaryData?.configurationDescriptionList; track line) {
                              <p class="summary-details">- {{ line | titlecase }}</p>
                            }
                          </div>
                          <button class="print-button" (click)="printSummaryRecapPdf()">
                            <span>{{ 'STAMPA' | translate | titlecase }}</span>
                          </button>
                          @if (isPrinting) {
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (!loaded) {
                  <app-visionnaire-loader class="ipe:w-full"/>
                }
              </div>
            </cdk-virtual-scroll-viewport>
            <div class="conf-component-footer" [class.is-visible]="!workingPlacement"
                 [class.is-hidden]="!!workingPlacement">
              @if (!showPlacementsConfigurability || view === configurationView.CONFIGURATION_FINAL_SUMMARY) {
                <div class="width-50">
                  <button
                    (click)="editCurrentConfiguration(true)"
                    class="btn edit-configuration-btn">{{ "MODIFICA_CONFIGURAZIONE" | translate }}
                  </button>
                </div>
              }
              @if (showPlacementsConfigurability && view !== configurationView.CONFIGURATION_FINAL_SUMMARY) {
                <div class="width-50">
                  <button
                    (click)="editCurrentConfiguration(false)"
                    class="btn edit-configuration-btn">{{ "ANNULLA_CONFIGURAZIONE" | translate }}
                  </button>
                </div>
              }
              <div class="width-50" [hidden]="(view === configurationView.CONFIGURATION_FINAL_SUMMARY && loaded)">
                  <span
                    [matTooltip]="needActionForCreateNewUser() || (missingInfoForCustomer() || '') | translate"
                    matTooltipPosition="below">
                    <button
                      class="btn summary-button"
                      (click)="goToSummary()"
                    >
                      {{ 'RIEPILOGO' | translate }}
                    </button>
                  </span>
              </div>
              @if (!blockIfEtoCantRequested() && b2cAddToOrderEnabled) {
                <div class="width-50" [hidden]="!(view === configurationView.CONFIGURATION_FINAL_SUMMARY && loaded)">
                  <button
                    (click)="addConfToOrder()"
                    class="btn add-to-order"> {{ labelAddToProforma() | translate }}
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #saveConfModal>
  <h2 matDialogTitle>{{ 'SALVA_CONFIGURAZIONE' | translate }}</h2>
  <p matDialogContent>{{ 'SALVARE_CONFIGURAZIONE' | translate }}</p>
  <div class="p-3">
    <p class="form-element-label">{{ 'NOME_CONFIGURAZIONE' | translate }}</p>
    <input [(ngModel)]="configurationName" class="p-2 w-100" placeholder="{{'INSERISCI_NOME' | translate}}"
           type="text">
  </div>
  @if (modelConfiguration?.newPrebuilt && checkIfCanBuildNewPrebuilt()) {
    <div class="conf-slide-toggle">
      <mat-slide-toggle [(ngModel)]="default"
                        color="primary">{{ 'IMPOSTA_COME_PREDEFINITA' | translate }}
      </mat-slide-toggle>
    </div>
  }
  <mat-dialog-actions align="end">
    <button (click)="saveConf(false)" mat-button>{{ 'CONFERMA' | translate }}</button>
    <button mat-button matDialogClose>{{ 'ANNULLA' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #backToConf>
  <h2 matDialogTitle>{{ 'MODELLO' | translate }}</h2>
  <p matDialogContent>{{ 'CAMBIARE_MODELLO' | translate }}</p>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="true" mat-button>{{ 'CONFERMA' | translate }}</button>
    <button [mat-dialog-close]="false" mat-button matDialogClose>{{ 'ANNULLA' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #resetConf>
  <h2 matDialogTitle>{{ 'ANNULLA_CONFIGURAZIONE' | translate }}</h2>
  <p matDialogContent>{{ 'PROSEGUI' | translate }}</p>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="true" mat-button>{{ 'CONFERMA' | translate }}</button>
    <button [mat-dialog-close]="false" mat-button matDialogClose>{{ 'ANNULLA' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #askToDeactivateLines>
  <h2 matDialogTitle>{{ 'AVVISO_LINEE' | translate }}</h2>
  <p matDialogContent>{{ 'LINEE_DA_RICONFIGURARE' | translate }}</p>
  <ul class="list-line-to-be-configured">
    @for (placementToDeactivate of placementsToAskDeactivate; track placementsToAskDeactivate) {
      <li>{{ placementToDeactivate.placementName }}</li>
    }
  </ul>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="'deactivate'" mat-button>{{ 'RICONFIGURA' | translate }}</button>
    <button [mat-dialog-close]="'reset'" mat-button>{{ 'RESET' | translate }}</button>
    <button [mat-dialog-close]="false" mat-button matDialogClose>{{ 'ANNULLA' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #askToRestore>
  <h2 matDialogTitle>{{ 'RIPRISTINARE' | translate }}</h2>
  <p matDialogContent>{{ 'AVVISO_RIPRISTINARE' | translate }}</p>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="true" mat-button>{{ 'RIPRENDI' | translate }}</button>
    <button [mat-dialog-close]="false" mat-button matDialogClose>{{ 'RICOMINCIA' | translate }}</button>
  </mat-dialog-actions>
</ng-template>

